module.exports = __webpack_public_path__ + "static/img/42.6c2c72e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/flag_icons/42.png
// module id = 6rNG
// module chunks = 1